import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c901fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "NewDatePicker",
  ref: "elementref"
}
const _hoisted_2 = { class: "NewDatePicker__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_calendar = _resolveComponent("new-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_input, {
        freeze: "",
        "is-invalid": _ctx.isInvalid,
        "validation-errors": _ctx.validationErrors,
        value: _ctx.computedValue,
        placeholder: _ctx.placeholder,
        "icon-right-clickable": "",
        onClickIconRight: _ctx.onClick
      }, {
        "icon-right": _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["is-invalid", "validation-errors", "value", "placeholder", "onClickIconRight"]),
      (_ctx.is_opened)
        ? (_openBlock(), _createBlock(_component_new_calendar, {
            key: 0,
            "disabled-dates": _ctx.disabledDates,
            format: _ctx.format,
            value: _ctx.value,
            disabled: _ctx.disabled,
            range: _ctx.range,
            onChange: _ctx.onChange
          }, null, 8, ["disabled-dates", "format", "value", "disabled", "range", "onChange"]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}